export default function Modal(props) {
    const { isOpen, children } = props;
    if (!isOpen) {
        return null;
    }

    return <div>{children}</div>;
}
